import { useTranslation } from 'react-i18next'
import './Popup.css'
import { memo } from 'react'

import { ReactComponent as CloseIcon } from '../../icon/close.svg'

const PopupComponent = (props) => {
	const { t } = useTranslation()

	return (
		<div className="popup__container">
			<div className="popup__wrapper">
				<div className="popup__header">
					<h2 className="popup__title">
						{ t(props.title) }
					</h2>

					{
						props?.close &&
							<CloseIcon onClick={props.onClose} className="popup__close-icon" />
					}
				</div>

				<div className="popup__body">
					{ props.children }
				</div>
			</div>
		</div>
	)
}

export const Popup = memo(PopupComponent)